import gql from 'graphql-tag';

// This is used in GlobalNav
export const getMessageNotificationForAssociate = gql`
  query getMessageNotificationForAssociate($associateId: String) {
    getMessageNotificationForAssociate(associateId: $associateId) {
      associateId
      contactId
      notificationCount
    }
  }
`;

// This is used in GlobalNav
export const getNotificationCountForAssociate = gql`
  query getNotificationCountForAssociate($associateId: String) {
    getNotificationCountForAssociate(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is used in notifications
export const getEventsForAssociate = gql`
  query getEventsForAssociate($associateId: String) {
    getEventsForAssociate(associateId: $associateId) {
      eventId
      associateId
      event_status
      type
      description
      timestamp
      customerName
      message
      customerId
    }
  }
`;
